import styled from '@emotion/styled';
import { Row } from 'antd';

export const StyledRow = styled(Row)`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;
